module.exports = __webpack_public_path__ + "static/media/Business-River-Logo-White.f71693b3.png";